export default __webpack_public_path__ + "static/media/804.260cf4a1.gif";